import { AllEnvironmentName, EnvironmentName, EnvironmentType, LocalEnvironmentName, MystiqueEnvironmentHost } from "../constants/environments.js";

export type ProdMystiqueHostsToEnvironmentNameMap = Readonly<{
    [MystiqueEnvironmentHost.PROD]: EnvironmentName.PROD;
}>;
export type ProdEnvironmentNameToMystiqueHostsMap = Readonly<{
    [EnvironmentName.PROD]: MystiqueEnvironmentHost.PROD;
}>;
export type StagingMystiqueHostsToEnvironmentNameMap = Readonly<Record<MystiqueEnvironmentHost, AllEnvironmentName | undefined>>;
export type StagingEnvironmentNameToMystiqueHostsMap = Readonly<Record<AllEnvironmentName, MystiqueEnvironmentHost | undefined>>;
export type GetMystiqueHostsToEnvironmentNameMapReturnType<Type extends EnvironmentType> = Type extends EnvironmentType.PROD
    ? ProdMystiqueHostsToEnvironmentNameMap
    : Type extends EnvironmentType.STAGING
      ? StagingMystiqueHostsToEnvironmentNameMap
      : never;
export type GetEnvironmentNameToMystiqueHostsReturnType<Type extends EnvironmentType> = Type extends EnvironmentType.PROD
    ? ProdEnvironmentNameToMystiqueHostsMap
    : Type extends EnvironmentType.STAGING
      ? StagingEnvironmentNameToMystiqueHostsMap
      : never;
const EnvironmentNameToMystiqueHostsMap: {
    [Type in EnvironmentType]: GetMystiqueHostsToEnvironmentNameMapReturnType<Type>;
} = {
    [EnvironmentType.PROD]: {
        [MystiqueEnvironmentHost.PROD]: EnvironmentName.PROD,
    },
    [EnvironmentType.STAGING]: {
        [MystiqueEnvironmentHost.PROD]: EnvironmentName.PROD,
        [MystiqueEnvironmentHost.KAPPA]: EnvironmentName.KAPPA,
        [MystiqueEnvironmentHost.ALPHA]: EnvironmentName.ALPHA,
        [MystiqueEnvironmentHost.BETA]: EnvironmentName.BETA,
        [MystiqueEnvironmentHost.GAMMA]: EnvironmentName.GAMMA,
        [MystiqueEnvironmentHost.LOCAL]: EnvironmentName.PROD,
        [MystiqueEnvironmentHost.LOCAL2]: LocalEnvironmentName.LOCAL2,
        [MystiqueEnvironmentHost.DELTA]: EnvironmentName.DELTA,
        [MystiqueEnvironmentHost.EPSILON]: EnvironmentName.EPSILON,
        [MystiqueEnvironmentHost.LAMBDA]: EnvironmentName.LAMBDA,
        [MystiqueEnvironmentHost.OMEGA]: EnvironmentName.OMEGA,
        [MystiqueEnvironmentHost.ZETA]: EnvironmentName.ZETA,
        [MystiqueEnvironmentHost.SIGMA]: EnvironmentName.SIGMA,
        [MystiqueEnvironmentHost.THETA]: EnvironmentName.THETA,
        [MystiqueEnvironmentHost.IOTA]: EnvironmentName.IOTA,
        [MystiqueEnvironmentHost.PSI]: EnvironmentName.PSI,
        [MystiqueEnvironmentHost.NU]: EnvironmentName.NU,
        [MystiqueEnvironmentHost.MU]: EnvironmentName.MU,
        [MystiqueEnvironmentHost.CHI]: EnvironmentName.CHI,
        [MystiqueEnvironmentHost.RHO]: EnvironmentName.RHO,
        [MystiqueEnvironmentHost.FAKER]: EnvironmentName.FAKER,
        [MystiqueEnvironmentHost.OMICRON]: EnvironmentName.OMICRON,
        [MystiqueEnvironmentHost.UMI]: EnvironmentName.UMI,
        [MystiqueEnvironmentHost.HADES]: EnvironmentName.HADES,
        [MystiqueEnvironmentHost.VOLDEMORT]: EnvironmentName.VOLDEMORT,
    },
};
const MystiqueHostsToEnvironmentNameMap: {
    [Type in EnvironmentType]: GetEnvironmentNameToMystiqueHostsReturnType<Type>;
} = {
    [EnvironmentType.PROD]: {
        [EnvironmentName.PROD]: MystiqueEnvironmentHost.PROD,
    },
    [EnvironmentType.STAGING]: {
        [EnvironmentName.PROD]: MystiqueEnvironmentHost.PROD,
        [EnvironmentName.KAPPA]: MystiqueEnvironmentHost.KAPPA,
        [EnvironmentName.ALPHA]: MystiqueEnvironmentHost.ALPHA,
        [EnvironmentName.BETA]: MystiqueEnvironmentHost.BETA,
        [EnvironmentName.GAMMA]: MystiqueEnvironmentHost.GAMMA,
        [LocalEnvironmentName.LOCAL]: MystiqueEnvironmentHost.LOCAL,
        [LocalEnvironmentName.LOCAL2]: MystiqueEnvironmentHost.LOCAL2,
        [EnvironmentName.DELTA]: MystiqueEnvironmentHost.DELTA,
        [EnvironmentName.EPSILON]: MystiqueEnvironmentHost.EPSILON,
        [EnvironmentName.LAMBDA]: MystiqueEnvironmentHost.LAMBDA,
        [EnvironmentName.OMEGA]: MystiqueEnvironmentHost.OMEGA,
        [EnvironmentName.ZETA]: MystiqueEnvironmentHost.ZETA,
        [EnvironmentName.SIGMA]: MystiqueEnvironmentHost.SIGMA,
        [EnvironmentName.THETA]: MystiqueEnvironmentHost.THETA,
        [EnvironmentName.IOTA]: MystiqueEnvironmentHost.IOTA,
        [EnvironmentName.PSI]: MystiqueEnvironmentHost.PSI,
        [EnvironmentName.NU]: MystiqueEnvironmentHost.NU,
        [EnvironmentName.MU]: MystiqueEnvironmentHost.MU,
        [EnvironmentName.CHI]: MystiqueEnvironmentHost.CHI,
        [EnvironmentName.RHO]: MystiqueEnvironmentHost.RHO,
        [EnvironmentName.FAKER]: MystiqueEnvironmentHost.FAKER,
        [EnvironmentName.OMICRON]: MystiqueEnvironmentHost.OMICRON,
        [EnvironmentName.UMI]: MystiqueEnvironmentHost.UMI,
        [EnvironmentName.HADES]: MystiqueEnvironmentHost.HADES,
        [EnvironmentName.VOLDEMORT]: MystiqueEnvironmentHost.VOLDEMORT,
    },
};
export const getMystiqueHostsToEnvironmentNameMap = <Type extends EnvironmentType>(params: {
    environmentType: Type;
}): GetMystiqueHostsToEnvironmentNameMapReturnType<Type> => {
    return EnvironmentNameToMystiqueHostsMap[params.environmentType];
};
export const getEnvironmentNameToMystiqueHostsMap = <Type extends EnvironmentType>(params: {
    environmentType: Type;
}): GetEnvironmentNameToMystiqueHostsReturnType<Type> => {
    return MystiqueHostsToEnvironmentNameMap[params.environmentType];
};
export const isMystiqueHostKey = (key: string): key is MystiqueEnvironmentHost => {
    return key in MystiqueEnvironmentHost;
};
